export const GroupsRestrictions = {
    maxGroupNameLength: 40,
};
